// extracted by mini-css-extract-plugin
export default {"EledoTemplateRoot":"EledoTemplateRoot_EledoTemplateRoot__5ZrNX","content-wrapper":"EledoTemplateRoot_content-wrapper__AGUMM"};